import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";
import mathHelper from "../Helpers/mathHelper";
import stringHelper from "../Helpers/stringHelper";
import urlHelper from "../Helpers/urlHelper";

class IobItem {
  constructor(item) {
    if (item === undefined) {
      this.IobinvoiceId = '';
      this.Type = '';
      this.FromOfficeName = '';
      this.ToOfficeName = '';
      this.CurrencySymbol = '';
      this.AmountTotal = '';
      this.AmountPaid = '';
      this.AmountDue = '';
      this.InternalReferenceNumber = '';
      this.Status = '';
      this.Source = '';
      this.SourceClientName = '';
      this.RevenueMonth = '';
      this.CreatedOn = '';
      this.CreatedByName = '';
      this.ModifiedOn = '';
      this.ModifiedByName = '';
      this.CurrencyName = '';
      this.ClientName = '';
      this.ClientId = '';
      this.ProjectDisplayName = '';
      this.ProjectId = '';
      this.FinalizedOn = '';
      this.FinalizedByName = '';
      this.Comments = '';
      this.ToOfficeId = '';
    } else {
      this.IobinvoiceId = item.iobinvoiceId;
      this.Type = item.type;
      this.FromOfficeName = item.fromOfficeName;
      this.ToOfficeName = item.toOfficeName;
      this.CurrencySymbol = item.currencySymbol;
      this.AmountTotal = mathHelper.ConvertToTwoDecimalNumber(item.amountTotal);
      this.AmountPaid = mathHelper.ConvertToTwoDecimalNumber(item.amountPaid);
      this.AmountDue = mathHelper.ConvertToTwoDecimalNumber(item.amountDue);
      this.InternalReferenceNumber = stringHelper.isEmpty(item.internalReferenceNumber)
        ? ' '
        : item.internalReferenceNumber;
      this.Status = item.status;
      this.Source = item.source === null ? ' ' : item.source;
      this.SourceClientName = item.sourceClientName;
      this.RevenueMonth = item.revenueMonth;
      this.CreatedOn = item.createdOn;
      this.FormattedCreatedOn = dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.createdOn, '/');
      this.CreatedByName = item.createdByName;
      this.ModifiedOn = item.modifiedOn;
      this.FormattedModifiedOn = dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.modifiedOn, '/');
      this.ModifiedByName = item.modifiedByName;
      this.CurrencyName = item.currencyName;
      this.ClientName = stringHelper.isEmpty(item.clientName) ? ' ' : item.clientName;
      this.ProjectDisplayName = stringHelper.isEmpty(item.projectDisplayName) ? ' ' : item.projectDisplayName;
      this.FinalizedOn = stringHelper.isEmpty(item.finalizedOn)
        ? ' '
        : dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.finalizedOn, '/');
      this.FinalizedByName = stringHelper.isEmpty(item.finalizedByName) ? ' ' : item.finalizedByName;
      this.Comments = stringHelper.isEmpty(item.comments) ? ' ' : item.comments;
      this.ToOfficeId = item.toOfficeId;
    }
    this.Selected = false;
  }

  static NameOfTheIdField() {
    return 'IobinvoiceId';
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static finalizeFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static markAsPaidFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static nameOfTheItemDetailList() {
    return 'IOB';
  }

  static Currency() {
    return 'CurrencyName';
  }

  static CurrencySecondary() {
    return '';
  }

  static MoneyFields = ['AmountTotal', 'AmountPaid', 'AmountDue'];
  static MoneyFieldsSecondary = [];
  static DateFields = [];
  static BoolFields = [];
  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'IobinvoiceId', label: 'IOB ID', className: 'text-left' },
        { name: 'FromOfficeName', label: 'FW Office', className: 'text-left' },
        { name: 'ToOfficeName', label: 'Bill To Office', className: 'text-left' },
        { name: 'Type', label: 'IOB Type', className: 'text-left' },
        { name: 'CurrencyName', label: 'Currency', className: 'text-left' },
        { name: 'RevenueMonth', label: 'Revenue Month', className: 'text-left' },
        { name: 'Source', label: 'Source', className: 'text-left' },
        { name: 'InternalReferenceNumber', label: 'Internal Reference Number', className: 'text-left' },
        { name: 'Status', label: 'Status', className: 'text-left' },
        { name: 'ClientName', label: 'Client', className: 'text-left' },
        { name: 'ProjectDisplayName', label: 'Project', className: 'text-left' },
        { name: '-', label: '' },
        { name: 'FinalizedOn', label: 'Finalized On', className: 'text-left' },
        { name: 'FinalizedByName', label: 'Finalized By', className: 'text-left' },
        { name: '-message-', label: 'Billing Totals' },
        { name: 'AmountTotal', label: 'Total', className: 'text-left' },
        { name: 'AmountPaid', label: 'Paid', className: 'text-left' },
        { name: 'AmountDue', label: 'Due', className: 'text-left' },
        { name: 'Comments', label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Id', orderById: 'IobinvoiceId', data: IobItem.GetDetailCellContent, minWidth: 70 },
      {
        label: IobItem.getSelectedCellHeader,
        orderById: '',
        data: IobItem.getSelectedCellContent,
        className: 'text-center',
        minWidth: 20,
      },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'FW Office', orderById: 'FromOfficeName', data: 'FromOfficeName' },
      { label: 'Bill To Office', orderById: 'ToOfficeName', data: 'ToOfficeName' },
      { label: 'Total', orderById: 'AmountTotal', data: 'AmountTotal' },
      { label: 'Paid', orderById: 'AmountPaid', data: 'AmountPaid' },
      {
        label: 'Internal Reference #',
        orderById: 'InternalReferenceNumber',
        data: 'InternalReferenceNumber',
        minWidth: 150,
      },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Source', orderById: 'Source', data: 'Source' },
      { label: 'Client Name from Source', orderById: 'SourceClientName', data: 'SourceClientName', minWidth: 175 },
      { label: 'YRMO', orderById: 'RevenueMonth', data: 'RevenueMonth' },
      { label: 'Created On', orderById: 'CreatedOn', data: 'FormattedCreatedOn' },
      {
        label: ' ',
        orderById: '',
        data: IobItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader() {
    return (
      <input
        type='checkbox'
        checked={IobItem.selectedStatus()}
        onChange={(e) => {
          IobItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            IobItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnSelect(item, selected) {}

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.IobinvoiceId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'iobdetails',
      `id=${item.IobinvoiceId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            roleKey: 'iob_editfinalizemarkaspaidlineitemedit',
            onClick: () => IobItem.editGeneralFunction(item.IobinvoiceId, item),
          },
          {
            iconName: 'fa-solid fa-flag-checkered',
            text: 'Finalize',
            roleKey: 'iob_editfinalizemarkaspaidlineitemedit',
            disabled: item.Status !== 'Draft',
            onClick: () => IobItem.finalizeFunction(item.IobinvoiceId, item),
          },
          {
            iconName: 'fa-solid fa-money-bill',
            text: 'Mark as Paid',
            roleKey: 'iob_editfinalizemarkaspaidlineitemedit',
            disabled: item.Status !== 'Finalized',
            onClick: () => IobItem.markAsPaidFunction(item.IobinvoiceId, item),
          },
        ]}
      />
    );
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };
}

export default IobItem;
